import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';
import type { IDriveContent } from 'src/@types/drive';
import {
  type DriveCreateFolderPayload,
  DriveRequests,
} from 'src/requests/drive';
import { QueryKey } from 'src/utils/react-query';

export const useCreateFolderMutation = () => {
  const queryClient = useQueryClient();
  const { folderId } = useParams();
  const queryKey = [QueryKey.DRIVE, folderId || ''];

  const { mutateAsync: createFolder, isLoading: isCreatingFolder } =
    useMutation(
      async ({ name }: DriveCreateFolderPayload) =>
        DriveRequests.createFolder({ name, parent: folderId }),
      {
        onSuccess(newContent) {
          queryClient.setQueryData<IDriveContent[]>(queryKey, (contents) => [
            ...(contents || []),
            newContent,
          ]);
        },
      },
    );
  return {
    createFolder,
    isCreatingFolder,
  };
};
